import { findApplicant } from '@hc-frontend/business'
import { INVALID_PROFILE_EXCEPTION } from 'core/constants/exceptions'

function validateProfile(store: Pivot.State): Pivot.State {
  const applicant = findApplicant(store.hcStorage.members)
  if (!(applicant.dob && applicant.gender && store.hcStorage.location.zip_code)) {
    throw INVALID_PROFILE_EXCEPTION
  }

  return store
}

export default validateProfile
